var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "label-width": "60px",
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("settingZones.header.province"),
                          prop: "provinceId",
                        },
                      },
                      [
                        _c("BjSelectChinaArea", {
                          staticClass: "full-width",
                          attrs: { all: "", clearable: "" },
                          on: { change: _vm.changeProvince },
                          model: {
                            value: _vm.queryParams.provinceId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "provinceId", $$v)
                            },
                            expression: "queryParams.provinceId",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("settingZones.header.city"),
                          prop: "cityId",
                        },
                      },
                      [
                        _c("BjSelectChinaArea", {
                          staticClass: "full-width",
                          attrs: {
                            type: "city",
                            all: "",
                            "parent-code": _vm.queryParams.provinceId,
                            disabled: !_vm.queryParams.provinceId,
                          },
                          on: {
                            change: function ($event) {
                              _vm.queryParams.areaId = null
                            },
                          },
                          model: {
                            value: _vm.queryParams.cityId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "cityId", $$v)
                            },
                            expression: "queryParams.cityId",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("settingZones.header.district"),
                          prop: "areaId",
                        },
                      },
                      [
                        _c("BjSelectChinaArea", {
                          staticClass: "full-width",
                          attrs: {
                            type: "area",
                            all: "",
                            disabled: !(
                              _vm.queryParams.provinceId &&
                              _vm.queryParams.cityId
                            ),
                            "parent-code": _vm.queryParams.cityId,
                          },
                          model: {
                            value: _vm.queryParams.areaId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "areaId", $$v)
                            },
                            expression: "queryParams.areaId",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("table.statusText"),
                          prop: "enabledFlag",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: { "option-list": _vm.STATUS_ENABLED_TRUE },
                          model: {
                            value: _vm.queryParams.enabledFlag,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "enabledFlag", $$v)
                            },
                            expression: "queryParams.enabledFlag",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function (tableOperationProp) {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName:
                              "v-permission:SettingLogisticsStrategyZonesIndex_Delete",
                            arg: "SettingLogisticsStrategyZonesIndex_Delete",
                          },
                        ],
                        attrs: {
                          disabled: tableOperationProp.notSelected,
                          type: "primary",
                        },
                        on: { click: _vm.onDeleteSelected },
                      },
                      [_vm._v(_vm._s(_vm.$t("delText")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName:
                              "v-permission:SettingLogisticsStrategyZonesIndex_Add",
                            arg: "SettingLogisticsStrategyZonesIndex_Add",
                          },
                        ],
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.onAdd },
                      },
                      [_vm._v(_vm._s(_vm.$t("addText")))]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                            "show-overflow-tooltip":
                              col.prop !== "bjTableAction",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "amountStart"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(scope.row.amountStart) +
                                              " ~ " +
                                              _vm._s(scope.row.amountEnd) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "enabledFlag"
                                      ? [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: scope.row[col.prop]
                                                  ? "success"
                                                  : "info",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.STATUS_ENABLED_TRUE.bjGet(
                                                      scope.row[col.prop]
                                                    )
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName:
                                              "v-permission:SettingLogisticsStrategyZonesIndex_Edit",
                                            arg: "SettingLogisticsStrategyZonesIndex_Edit",
                                          },
                                        ],
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEdit(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("editText")))]
                                    ),
                                    !props.row.enabledFlag
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "permission",
                                                rawName:
                                                  "v-permission:SettingLogisticsStrategyZonesIndex_Status",
                                                arg: "SettingLogisticsStrategyZonesIndex_Status",
                                              },
                                            ],
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onStatus(
                                                  true,
                                                  props.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("enableText")))]
                                        )
                                      : _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "permission",
                                                rawName:
                                                  "v-permission:SettingLogisticsStrategyZonesIndex_Status",
                                                arg: "SettingLogisticsStrategyZonesIndex_Status",
                                              },
                                            ],
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onStatus(
                                                  false,
                                                  props.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("disableText"))
                                            ),
                                          ]
                                        ),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName:
                                              "v-permission:SettingLogisticsStrategyZonesIndex_Delete",
                                            arg: "SettingLogisticsStrategyZonesIndex_Delete",
                                          },
                                        ],
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDelete(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("delText")))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("DataForm", {
        ref: "DataForm",
        attrs: { "disabled-list": _vm.disabledList },
        on: { reFresh: _vm.reFresh },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }